import { useRef, useState } from 'react';
import Prontuarios from '../services/Prontuarios';
import { SweetAlert } from './sweetalert';
import { useAuth } from '../context/auth';
import { latestProntuario } from '../utilities/latestProntuario';
import { prontuarioLabel } from '../utilities/prontuarioLabel';

// Prontuário já preenchido ao escolher o paciente, no agendamento e no contrato: o único dele ou, com mais de um, o
// último cadastrado. A lupa continua liberada para trocar. showProgress: o texto do campo leva os atendimentos, como
// na busca de prontuários. Sem a lista de prontuários (read:prontuario:list) não busca: a lupa também não listaria.
// onFill recebe o prontuário preenchido (o agendamento traz o doutor dele)
export function useLatestProntuario({ getValues, setValue, showProgress = false, onFill }) {
  const { user } = useAuth();
  const canList = Boolean(user?.features?.includes('read:prontuario:list'));
  const [loading, setLoading] = useState(false);
  const sequence = useRef(0); // só a busca mais recente preenche

  async function fill(pacienteId) {
    const mine = ++sequence.current;
    if (!canList || !pacienteId) {
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      const { data } = await Prontuarios.listAll(1, { paciente: pacienteId });
      const prontuario = latestProntuario(data.data);

      // Só preenche se o paciente continua o mesmo e o campo ainda está vazio (ninguém escolheu outro enquanto buscava)
      if (mine !== sequence.current || !prontuario) return;
      if (getValues('paciente_id') !== pacienteId || getValues('prontuario_id')) return;

      setValue('prontuario', showProgress ? prontuarioLabel(prontuario) : prontuario.titulo);
      setValue('prontuario_id', prontuario.id);
      onFill?.(prontuario);
    } catch (error) {
      if (mine === sequence.current) {
        SweetAlert.error(`Não foi possível trazer o prontuário do paciente. ${error?.response?.data?.message ?? error?.message ?? ''}`, 'Prontuário');
      }
    } finally {
      if (mine === sequence.current) setLoading(false);
    }
  }

  // Descarta a busca em andamento (o formulário foi limpo)
  function cancel() {
    sequence.current++;
    setLoading(false);
  }

  return { fill, cancel, loading };
}
